// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_3lgDy","productBadge":"_82ToA","badge":"SjTfh","defaultImage":"_1_rxw"};